import { gettext_noop } from 'lib/gettext'

const messages = {
  required: gettext_noop('Please specify required field'),
  email: gettext_noop('Incorrect email'),
  url: gettext_noop('Incorrect url'),
  alternativeRequiredText: gettext_noop('This field is required'),
  greaterOrEqualToDefaultyearFrom:
    "Must be greater or equal to 'Default year covered from'",
  greaterOrEqualToyearFrom: "Must be greater or equal to 'from'",
  onlyUploadedFiles: gettext_noop('You have files in progress'),
  onlyUploadedAttachments: gettext_noop('You have files in progress'),
  tagsRequired: gettext_noop('You must specify at least one tag'),
  branchesRequired: gettext_noop('You must specify at least one branch'),
  regionRequired: gettext_noop(
    'You must select one of the variants, which are presented below'
  ),
  topLevelTagRequired: gettext_noop(
    'You must specify at least one top-level tag'
  ),
  twoTagsFromEachRequiredGroupRequired: gettext_noop(
    'You must specify at least one top-level tag and one second-level tag from each required tag group'
  ),
  twoTopLevelsTagRequired: gettext_noop(
    'You must specify at least one top-level tag and one second-level tag'
  ),
  numericTextInputRequired: gettext_noop('The value must be numeric'),
  percentTextInputRequired: gettext_noop('The value must be from 0 to 100'),
  expertFilledOnExpertSource: gettext_noop('You must specify an expert'),
  secondarySourceFilled: gettext_noop(
    'Select existing secondary source or create new'
  ),
  externalUrlFilled: gettext_noop(
    "Invalid URL. You must enter a valid URL including 'http://'"
  ),
  otherDataSourceNameFilled: gettext_noop(
    'You must provide a name for the data source'
  ),
  otherSecondarySourceNameFilled: gettext_noop(
    'You must provide a name for the secondary source'
  ),
}

export default messages
